<template>
  <v-container fluid id="experience">
    <v-row no-gutters style="padding: 30px 0 50px;">
      <v-container style="color: white">
        <v-row no-gutters justify="center" class="text-center">
          <div style="width: 100%;"><h2 class="display-2 font-weight-black">{{$t('experience.title')}}</h2></div>
        </v-row>
      </v-container>
    </v-row>

    <v-row align="center" justify="center">
      <img src="../assets/global_import_sign.png" width="60" height="60">
    </v-row>
    <v-row>
      <v-container style="color: white">
        <v-row justify="center" align="center" class="text-center" style="padding-bottom: 30px">
          <h1>{{$t('experience.import.title')}}</h1>
        </v-row>
        <v-row justify="center" align="start" class="text-center">
          <v-spacer/>
          <v-col class="round-block">{{$t('experience.import.text1')}}</v-col>
          <v-col class="round-block">{{$t('experience.import.text2')}}</v-col>
          <v-col class="round-block">{{$t('experience.import.text3')}}</v-col>
          <v-col class="round-block">{{$t('experience.import.text4')}}</v-col>
          <v-spacer/>
        </v-row>
        <v-row justify="center" align="start" class="text-center">
          <v-spacer/>
          <v-col class="round-block">{{$t('experience.import.text5')}}</v-col>
          <v-col class="round-block">{{$t('experience.import.text6')}}</v-col>
          <v-col class="round-block">{{$t('experience.import.text7')}}</v-col>
          <v-spacer/>
        </v-row>
        <v-row justify="center" align="start" class="text-center">
          <v-spacer/>
          <v-col class="round-block">{{$t('experience.import.text8')}}</v-col>
          <v-col class="round-block">{{$t('experience.import.text9')}}</v-col>
          <v-spacer/>
        </v-row>
      </v-container>
    </v-row>

    <v-row align="center" justify="center" style="padding-top: 50px">
      <img src="../assets/global_export_sign.png" width="60" height="60">
    </v-row>
    <v-row>
      <v-container style="color: white">
        <v-row justify="center" align="center" class="text-center" style="padding-bottom: 30px">
          <h1>{{$t('experience.export.title')}}</h1>
        </v-row>
        <v-row justify="center" align="start" class="text-center">
          <v-spacer/>
          <v-col class="round-block">{{$t('experience.export.text1')}}</v-col>
          <v-spacer/>
        </v-row>
      </v-container>
    </v-row>
  </v-container>

</template>

<script>
  export default {
    name: 'Global'
  }
</script>

<style scoped>
  #experience {
    /*background: linear-gradient(#006599, #24659F);*/
  }
  .round-block {
    border: 1px solid white;
    border-radius: 5px;
    margin: 10px;
  }
</style>
